var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"generic-tooltip"},[_c('v-menu',{attrs:{"nudge-left":50,"close-delay":"300","left":"","offset-y":"","open-delay":"100","open-on-hover":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_vm._v(_vm._s(_vm.title)+" "),_c('to-icon',[_vm._v("info")])],1)]}}])},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }